import { Component } from "@angular/core";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { take } from "rxjs/operators";
import { CareplusFeeService } from "src/services/careplus-fee.service";
import { CareplusFee } from "src/dto/request/careplus-fee";

@Component({
  selector: "app-careplus-fee",
  templateUrl: "./careplus-fee.component.html",
  styleUrls: ["./careplus-fee.component.css"],
})
export class CareplusFeeComponent {
  isLoading = false;
  fee?: CareplusFee;
  constructor(
    private feeService: CareplusFeeService,
    private snackBar: MatSnackBar
  ) {
    this.loadFee();
  }

  loadFee() {
    this.isLoading = true;
    this.feeService
      .getFees()
      .pipe(take(1))
      .subscribe((x) => {
        this.fee = x;
        this.isLoading = false;
      });
  }

  updateFee() {
    this.isLoading = true;
    this.feeService
      .updateFees(this.fee)
      .pipe(take(1))
      .subscribe(() => {
        this.isLoading = false;
        this.snackBar.open("Fee updated successfully", "OK", {
          duration: 3000,
        });
      });
  }
}
